// eslint-disable-next-line import/prefer-default-export
export const TAM_SCRIPT = 'https://c.amazon-adsystem.com/aax2/apstag.js';
export const SCRIPT_TYPE = 'text/javascript';
export const TOI_PLUS_FB_EVENT =
  'https://connect.facebook.net/en_US/fbevents.js';
export const TOI_PLUS_GTAG_EVENT =
  'https://www.googletagmanager.com/gtag/js?id=AW-877820074';
export const GET_COL_JS = channnel => {
  if (channnel === 'etimes') {
    return 'https://static.clmbtech.com/ad/commons/js/65615/colombia_v2.js';
  }
  return 'https://static.clmbtech.com/ad/commons/js/2658/toi/colombia_v2.js';
};
export const TOI_BASE_DOMAIN = __PROD__
  ? 'https://timesofindia.indiatimes.com'
  : 'https://toidev.indiatimes.com';

export const SURVICATE_JS_URL =
  'https://survey.survicate.com/workspaces/0be6ae9845d14a7c8ff08a7a00bd9b21/web_surveys.js';

export const ONE_TRUST_URL =
  'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';

export const GPT_JS =
  'https://securepubads.g.doubleclick.net/tag/js/gpt.js?network-code=7176';

export const GPT_NEW_GAM_JS =
  'https://securepubads.g.doubleclick.net/tag/js/gpt.js?network-code=23037861279';

export const TIL_PREBID_JS = 'https://assets.toiimg.com/js/til_prebid.js?v=';
export const IMASDK_JS = 'https://imasdk.googleapis.com/js/sdkloader/ima3.js';

export const TOI_CORE_EXPERIMENTS_DEBUGBEAR_SCRIPT =
  'https://cdn.debugbear.com/WfVIXQplj2ct.js';

export const TOI_CORE_BASE_DEBUGBEAR_SCRIPT =
  'https://cdn.debugbear.com/46q56LkGchnK.js';

export const TOI_VIDEOSHOW_DEBUGBEAR_SCRIPT =
  'https://cdn.debugbear.com/tmzDX1JDMWkg.js';

export const CWV_REPORTING_JS = __PROD__
  ? 'toi_webvital_events_min_js.cms?v=4'
  : 'toi_webvital_events_js.cms';

export const POPUP_PRIORITY_JS = 'popup_manager_priority.cms';
